import React, { useState } from 'react';
import Card from '../../../../shared/components/Card';
import usePageTranslation from '../../../../shared/hooks/usePageTranslation';

const MOCK_CANDIDATES = [
  { id: '1', name: 'paulf31' },
];

const AllianceCandidates: React.FC = () => {
  const { t } = usePageTranslation('game', 'AlliancePage');
  const [candidates, setCandidates] = useState(MOCK_CANDIDATES);

  const handleAccept = (id: string) => {
    setCandidates((prev) => prev.filter((c) => c.id !== id));
  };

  const handleReject = (id: string) => {
    setCandidates((prev) => prev.filter((c) => c.id !== id));
  };

  return (
    <Card className="p-6">
      <h2 className="text-2xl font-bold text-white mb-4">{t('candidates.title')}</h2>
      <p className="text-sm font-semibold text-gray-400 mb-3">{t('candidates.colName')}</p>
      {candidates.length === 0 ? (
        <p className="text-gray-500 py-4">{t('candidates.noResults')}</p>
      ) : (
        <ul className="space-y-2">
          {candidates.map((c) => (
            <li
              key={c.id}
              className="flex items-center gap-3 py-2 border-b border-gray-700/50 last:border-0"
            >
              <span className="text-indigo-400 hover:text-indigo-300 font-medium">
                {c.name}
              </span>
              <span className="flex items-center gap-1 ml-auto">
                <button
                  type="button"
                  onClick={() => handleAccept(c.id)}
                  className="p-2 rounded-lg text-green-500 hover:bg-green-500/20 hover:text-green-400 transition-colors"
                  title={t('candidates.accept')}
                  aria-label={t('candidates.accept')}
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </button>
                <button
                  type="button"
                  onClick={() => handleReject(c.id)}
                  className="p-2 rounded-lg text-red-500 hover:bg-red-500/20 hover:text-red-400 transition-colors"
                  title={t('candidates.reject')}
                  aria-label={t('candidates.reject')}
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </span>
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
};

export default AllianceCandidates;
